import * as types from "./mutation-types";

export default {
  [types.SET_PEDIDOS](state, payload) {
    state.pedidos = payload;
  },
  [types.SET_PEDIDO](state, payload) {
    state.pedido = payload || {};
  },
  [types.SET_PAGINATION](state, payload) {
    state.pagination = payload || {};
  },
  [types.SET_ERROR](state, payload) {
    state.error = payload || {};
  },
};
